import { useTranslation } from "@ferrivia/i18n";
import type { OutboxEntryState } from "../useChatThread";
import s from "./DeliveryState.module.css";

export interface DeliveryStateProps {
  state: OutboxEntryState;
  onRetry?: () => void;
}

export function DeliveryState({ state, onRetry }: DeliveryStateProps) {
  const { t } = useTranslation("chat");
  const label: Record<OutboxEntryState, string> = {
    pending: t("delivery.pending", "Lähetetään…"),
    sent: t("delivery.sent", "Lähetetty"),
    failed: t("delivery.failed", "Ei mennyt perille"),
  };

  return (
    <span className={`${s.root} ${s[state]}`}>
      {label[state]}
      {state === "failed" && onRetry ? (
        <button type="button" className={s.retry} onClick={onRetry}>
          {t("delivery.retry", "Yritä uudelleen")}
        </button>
      ) : null}
    </span>
  );
}
